/**
 * Emoji icons (using native Unicode emojis)
 * Comprehensive collection for RPG/Fantasy knowledge bases
 */
export const EMOJI_ICONS = [
  // ═══════════════════════════════════════════════════════════════
  // FANTASY & RPG CHARACTERS
  // ═══════════════════════════════════════════════════════════════
  { value: '🧙', label: 'wizard' },
  { value: '🧙‍♂️', label: 'wizard-male' },
  { value: '🧙‍♀️', label: 'wizard-female' },
  { value: '🧝', label: 'elf' },
  { value: '🧝‍♂️', label: 'elf-male' },
  { value: '🧝‍♀️', label: 'elf-female' },
  { value: '🧚', label: 'fairy' },
  { value: '🧚‍♂️', label: 'fairy-male' },
  { value: '🧚‍♀️', label: 'fairy-female' },
  { value: '🧜', label: 'merperson' },
  { value: '🧜‍♂️', label: 'merman' },
  { value: '🧜‍♀️', label: 'mermaid' },
  { value: '🧞', label: 'genie' },
  { value: '🧞‍♂️', label: 'genie-male' },
  { value: '🧞‍♀️', label: 'genie-female' },
  { value: '🧛', label: 'vampire' },
  { value: '🧛‍♂️', label: 'vampire-male' },
  { value: '🧛‍♀️', label: 'vampire-female' },
  { value: '🧟', label: 'zombie' },
  { value: '🧟‍♂️', label: 'zombie-male' },
  { value: '🧟‍♀️', label: 'zombie-female' },
  { value: '🦸', label: 'superhero' },
  { value: '🦸‍♂️', label: 'superhero-male' },
  { value: '🦸‍♀️', label: 'superhero-female' },
  { value: '🦹', label: 'supervillain' },
  { value: '🦹‍♂️', label: 'supervillain-male' },
  { value: '🦹‍♀️', label: 'supervillain-female' },
  { value: '🥷', label: 'ninja' },
  { value: '🤴', label: 'prince' },
  { value: '👸', label: 'princess' },
  { value: '👑', label: 'crown' },
  { value: '🤵', label: 'noble-male' },
  { value: '👰', label: 'noble-female' },

  // Monsters & Creatures
  { value: '👹', label: 'ogre' },
  { value: '👺', label: 'goblin' },
  { value: '👻', label: 'ghost' },
  { value: '💀', label: 'skull' },
  { value: '☠️', label: 'skull-crossbones' },
  { value: '👽', label: 'alien' },
  { value: '👾', label: 'monster' },
  { value: '🤖', label: 'robot' },
  { value: '🎃', label: 'jack-o-lantern' },
  { value: '😈', label: 'devil' },
  { value: '👿', label: 'angry-devil' },
  { value: '💩', label: 'poop' },
  { value: '🤡', label: 'clown' },

  // ═══════════════════════════════════════════════════════════════
  // WEAPONS & COMBAT
  // ═══════════════════════════════════════════════════════════════
  { value: '⚔️', label: 'swords' },
  { value: '🗡️', label: 'dagger' },
  { value: '🏹', label: 'bow' },
  { value: '🛡️', label: 'shield' },
  { value: '🪓', label: 'axe' },
  { value: '🔪', label: 'knife' },
  { value: '🔨', label: 'hammer' },
  { value: '⛏️', label: 'pickaxe' },
  { value: '🪃', label: 'boomerang' },
  { value: '🏏', label: 'club' },
  { value: '🪵', label: 'wood-log' },
  { value: '💣', label: 'bomb' },
  { value: '🧨', label: 'dynamite' },
  { value: '🔫', label: 'pistol' },
  { value: '💥', label: 'explosion' },
  { value: '💢', label: 'anger' },
  { value: '🥊', label: 'boxing-glove' },
  { value: '🥋', label: 'martial-arts' },

  // ═══════════════════════════════════════════════════════════════
  // MAGIC & MYSTICAL
  // ═══════════════════════════════════════════════════════════════
  { value: '🪄', label: 'wand' },
  { value: '🔮', label: 'crystal-ball' },
  { value: '⚗️', label: 'alchemy' },
  { value: '🧪', label: 'potion' },
  { value: '🧫', label: 'petri-dish' },
  { value: '🧬', label: 'dna' },
  { value: '✨', label: 'sparkles' },
  { value: '⭐', label: 'star' },
  { value: '🌟', label: 'glowing-star' },
  { value: '💫', label: 'dizzy-star' },
  { value: '🌠', label: 'shooting-star' },
  { value: '🔯', label: 'star-of-david' },
  { value: '☪️', label: 'crescent' },
  { value: '✡️', label: 'hexagram' },
  { value: '☯️', label: 'yin-yang' },
  { value: '🕉️', label: 'om' },
  { value: '☸️', label: 'wheel-of-dharma' },
  { value: '⚛️', label: 'atom' },
  { value: '🧿', label: 'evil-eye' },
  { value: '🪬', label: 'hamsa' },
  { value: '♾️', label: 'infinity' },
  { value: '🎱', label: 'magic-8-ball' },

  // ═══════════════════════════════════════════════════════════════
  // ELEMENTS & NATURE
  // ═══════════════════════════════════════════════════════════════
  // Fire
  { value: '🔥', label: 'fire' },
  { value: '🕯️', label: 'candle' },
  { value: '🪔', label: 'lamp' },
  { value: '☄️', label: 'comet' },

  // Water
  { value: '💧', label: 'water' },
  { value: '💦', label: 'water-drops' },
  { value: '🌊', label: 'wave' },
  { value: '🫧', label: 'bubbles' },
  { value: '🧊', label: 'ice-cube' },
  { value: '❄️', label: 'snowflake' },
  { value: '🌨️', label: 'snow' },
  { value: '☃️', label: 'snowman' },
  { value: '⛄', label: 'snowman-no-snow' },

  // Air & Weather
  { value: '💨', label: 'wind' },
  { value: '🌪️', label: 'tornado' },
  { value: '🌬️', label: 'wind-face' },
  { value: '☁️', label: 'cloud' },
  { value: '⛅', label: 'partly-cloudy' },
  { value: '🌤️', label: 'sun-cloud' },
  { value: '🌥️', label: 'cloudy' },
  { value: '🌦️', label: 'sun-rain' },
  { value: '🌧️', label: 'rain' },
  { value: '⛈️', label: 'thunderstorm' },
  { value: '🌩️', label: 'lightning-cloud' },
  { value: '🌫️', label: 'fog' },

  // Lightning & Energy
  { value: '⚡', label: 'lightning' },
  { value: '🔆', label: 'bright' },
  { value: '🔅', label: 'dim' },

  // Earth
  { value: '🪨', label: 'rock' },
  { value: '🌋', label: 'volcano' },
  { value: '⛰️', label: 'mountain' },
  { value: '🏔️', label: 'snow-mountain' },
  { value: '🗻', label: 'mount-fuji' },
  { value: '🏕️', label: 'camping' },
  { value: '🏜️', label: 'desert' },
  { value: '🏝️', label: 'island' },
  { value: '🏖️', label: 'beach' },

  // Plants & Trees
  { value: '🌲', label: 'evergreen' },
  { value: '🌳', label: 'tree' },
  { value: '🌴', label: 'palm-tree' },
  { value: '🌵', label: 'cactus' },
  { value: '🌱', label: 'seedling' },
  { value: '🌿', label: 'herb' },
  { value: '☘️', label: 'shamrock' },
  { value: '🍀', label: 'four-leaf-clover' },
  { value: '🍁', label: 'maple-leaf' },
  { value: '🍂', label: 'fallen-leaf' },
  { value: '🍃', label: 'leaves' },
  { value: '🪴', label: 'potted-plant' },
  { value: '🪻', label: 'hyacinth' },
  { value: '🪷', label: 'lotus' },
  { value: '🌸', label: 'cherry-blossom' },
  { value: '💐', label: 'bouquet' },
  { value: '🌹', label: 'rose' },
  { value: '🥀', label: 'wilted-flower' },
  { value: '🌺', label: 'hibiscus' },
  { value: '🌻', label: 'sunflower' },
  { value: '🌼', label: 'blossom' },
  { value: '🌷', label: 'tulip' },
  { value: '🍄', label: 'mushroom' },
  { value: '🪸', label: 'coral' },

  // ═══════════════════════════════════════════════════════════════
  // CELESTIAL & TIME
  // ═══════════════════════════════════════════════════════════════
  { value: '☀️', label: 'sun' },
  { value: '🌞', label: 'sun-face' },
  { value: '🌙', label: 'crescent-moon' },
  { value: '🌛', label: 'moon-face-first' },
  { value: '🌜', label: 'moon-face-last' },
  { value: '🌝', label: 'full-moon-face' },
  { value: '🌚', label: 'new-moon-face' },
  { value: '🌕', label: 'full-moon' },
  { value: '🌖', label: 'waning-gibbous' },
  { value: '🌗', label: 'last-quarter' },
  { value: '🌘', label: 'waning-crescent' },
  { value: '🌑', label: 'new-moon' },
  { value: '🌒', label: 'waxing-crescent' },
  { value: '🌓', label: 'first-quarter' },
  { value: '🌔', label: 'waxing-gibbous' },
  { value: '🌍', label: 'earth-africa' },
  { value: '🌎', label: 'earth-americas' },
  { value: '🌏', label: 'earth-asia' },
  { value: '🪐', label: 'planet' },
  { value: '🌌', label: 'milky-way' },
  { value: '🌅', label: 'sunrise' },
  { value: '🌄', label: 'sunrise-mountains' },
  { value: '🌇', label: 'sunset' },
  { value: '🌆', label: 'cityscape-dusk' },
  { value: '🌃', label: 'night-stars' },
  { value: '🌉', label: 'bridge-night' },
  { value: '🌁', label: 'foggy' },
  { value: '🌈', label: 'rainbow' },
  { value: '⏰', label: 'alarm-clock' },
  { value: '⏳', label: 'hourglass' },
  { value: '⌛', label: 'hourglass-done' },
  { value: '🕐', label: 'clock-1' },
  { value: '🕛', label: 'clock-12' },

  // ═══════════════════════════════════════════════════════════════
  // CREATURES & ANIMALS
  // ═══════════════════════════════════════════════════════════════
  // Mythical
  { value: '🐉', label: 'dragon' },
  { value: '🐲', label: 'dragon-face' },
  { value: '🦄', label: 'unicorn' },
  { value: '🦅', label: 'eagle' },
  { value: '🦇', label: 'bat' },
  { value: '🦉', label: 'owl' },
  { value: '🦂', label: 'scorpion' },
  { value: '🕷️', label: 'spider' },
  { value: '🕸️', label: 'web' },
  { value: '🐍', label: 'snake' },
  { value: '🦎', label: 'lizard' },
  { value: '🐊', label: 'crocodile' },
  { value: '🐢', label: 'turtle' },
  { value: '🦈', label: 'shark' },
  { value: '🐙', label: 'octopus' },
  { value: '🦑', label: 'squid' },
  { value: '🦐', label: 'shrimp' },
  { value: '🦞', label: 'lobster' },
  { value: '🦀', label: 'crab' },
  { value: '🪼', label: 'jellyfish' },

  // Mammals
  { value: '🐺', label: 'wolf' },
  { value: '🦊', label: 'fox' },
  { value: '🐻', label: 'bear' },
  { value: '🐻‍❄️', label: 'polar-bear' },
  { value: '🐨', label: 'koala' },
  { value: '🐼', label: 'panda' },
  { value: '🦁', label: 'lion' },
  { value: '🐯', label: 'tiger' },
  { value: '🐆', label: 'leopard' },
  { value: '🐅', label: 'tiger-full' },
  { value: '🐈', label: 'cat' },
  { value: '🐈‍⬛', label: 'black-cat' },
  { value: '🐱', label: 'cat-face' },
  { value: '🐶', label: 'dog-face' },
  { value: '🐕', label: 'dog' },
  { value: '🐕‍🦺', label: 'service-dog' },
  { value: '🐩', label: 'poodle' },
  { value: '🦮', label: 'guide-dog' },
  { value: '🐗', label: 'boar' },
  { value: '🐖', label: 'pig' },
  { value: '🐷', label: 'pig-face' },
  { value: '🐽', label: 'pig-nose' },
  { value: '🐏', label: 'ram' },
  { value: '🐑', label: 'sheep' },
  { value: '🐐', label: 'goat' },
  { value: '🐪', label: 'camel' },
  { value: '🐫', label: 'two-hump-camel' },
  { value: '🦙', label: 'llama' },
  { value: '🦒', label: 'giraffe' },
  { value: '🐘', label: 'elephant' },
  { value: '🦣', label: 'mammoth' },
  { value: '🦏', label: 'rhino' },
  { value: '🦛', label: 'hippo' },
  { value: '🐭', label: 'mouse-face' },
  { value: '🐁', label: 'mouse' },
  { value: '🐀', label: 'rat' },
  { value: '🐹', label: 'hamster' },
  { value: '🐰', label: 'rabbit-face' },
  { value: '🐇', label: 'rabbit' },
  { value: '🐿️', label: 'squirrel' },
  { value: '🦫', label: 'beaver' },
  { value: '🦔', label: 'hedgehog' },
  { value: '🦇', label: 'bat' },
  { value: '🐴', label: 'horse-face' },
  { value: '🐎', label: 'horse' },
  { value: '🦌', label: 'deer' },
  { value: '🦬', label: 'bison' },
  { value: '🐂', label: 'ox' },
  { value: '🐃', label: 'water-buffalo' },
  { value: '🐄', label: 'cow' },
  { value: '🐮', label: 'cow-face' },
  { value: '🦝', label: 'raccoon' },
  { value: '🦨', label: 'skunk' },
  { value: '🦡', label: 'badger' },
  { value: '🦘', label: 'kangaroo' },
  { value: '🦥', label: 'sloth' },
  { value: '🦦', label: 'otter' },
  { value: '🐒', label: 'monkey' },
  { value: '🐵', label: 'monkey-face' },
  { value: '🦍', label: 'gorilla' },
  { value: '🦧', label: 'orangutan' },

  // Birds
  { value: '🐦', label: 'bird' },
  { value: '🐦‍⬛', label: 'black-bird' },
  { value: '🐤', label: 'chick' },
  { value: '🐣', label: 'hatching-chick' },
  { value: '🐥', label: 'front-chick' },
  { value: '🐔', label: 'chicken' },
  { value: '🐓', label: 'rooster' },
  { value: '🦆', label: 'duck' },
  { value: '🦢', label: 'swan' },
  { value: '🦩', label: 'flamingo' },
  { value: '🦚', label: 'peacock' },
  { value: '🦜', label: 'parrot' },
  { value: '🪶', label: 'feather' },
  { value: '🦤', label: 'dodo' },
  { value: '🐧', label: 'penguin' },
  { value: '🕊️', label: 'dove' },

  // Insects & Bugs
  { value: '🐛', label: 'bug' },
  { value: '🐜', label: 'ant' },
  { value: '🐝', label: 'bee' },
  { value: '🪲', label: 'beetle' },
  { value: '🐞', label: 'ladybug' },
  { value: '🦗', label: 'cricket' },
  { value: '🪳', label: 'cockroach' },
  { value: '🦟', label: 'mosquito' },
  { value: '🪰', label: 'fly' },
  { value: '🪱', label: 'worm' },
  { value: '🦋', label: 'butterfly' },
  { value: '🐌', label: 'snail' },
  { value: '🐚', label: 'shell' },

  // Sea Creatures
  { value: '🐳', label: 'whale' },
  { value: '🐋', label: 'whale-full' },
  { value: '🐬', label: 'dolphin' },
  { value: '🦭', label: 'seal' },
  { value: '🐟', label: 'fish' },
  { value: '🐠', label: 'tropical-fish' },
  { value: '🐡', label: 'blowfish' },

  // ═══════════════════════════════════════════════════════════════
  // BUILDINGS & LOCATIONS
  // ═══════════════════════════════════════════════════════════════
  { value: '🏰', label: 'castle' },
  { value: '🏯', label: 'japanese-castle' },
  { value: '🏛️', label: 'classical-building' },
  { value: '⛪', label: 'church' },
  { value: '🕌', label: 'mosque' },
  { value: '🛕', label: 'hindu-temple' },
  { value: '🕍', label: 'synagogue' },
  { value: '⛩️', label: 'shinto-shrine' },
  { value: '🕋', label: 'kaaba' },
  { value: '⛲', label: 'fountain' },
  { value: '⛺', label: 'tent' },
  { value: '🏠', label: 'house' },
  { value: '🏡', label: 'house-garden' },
  { value: '🏘️', label: 'houses' },
  { value: '🏚️', label: 'derelict-house' },
  { value: '🏢', label: 'office-building' },
  { value: '🏣', label: 'post-office-jp' },
  { value: '🏤', label: 'post-office' },
  { value: '🏥', label: 'hospital' },
  { value: '🏦', label: 'bank' },
  { value: '🏨', label: 'hotel' },
  { value: '🏩', label: 'love-hotel' },
  { value: '🏪', label: 'convenience-store' },
  { value: '🏫', label: 'school' },
  { value: '🏬', label: 'department-store' },
  { value: '🏭', label: 'factory' },
  { value: '🏗️', label: 'construction' },
  { value: '🧱', label: 'bricks' },
  { value: '🪵', label: 'wood' },
  { value: '🛖', label: 'hut' },
  { value: '🗼', label: 'tower' },
  { value: '🗽', label: 'statue-of-liberty' },
  { value: '🗿', label: 'moai' },
  { value: '🪦', label: 'tombstone' },
  { value: '⚰️', label: 'coffin' },
  { value: '⚱️', label: 'urn' },
  { value: '🚪', label: 'door' },
  { value: '🪟', label: 'window' },
  { value: '🛗', label: 'elevator' },
  { value: '🪜', label: 'ladder' },

  // ═══════════════════════════════════════════════════════════════
  // TREASURE & VALUABLES
  // ═══════════════════════════════════════════════════════════════
  { value: '💎', label: 'gem' },
  { value: '💍', label: 'ring' },
  { value: '📿', label: 'beads' },
  { value: '🏅', label: 'medal' },
  { value: '🥇', label: 'gold-medal' },
  { value: '🥈', label: 'silver-medal' },
  { value: '🥉', label: 'bronze-medal' },
  { value: '🏆', label: 'trophy' },
  { value: '🎖️', label: 'military-medal' },
  { value: '💰', label: 'money-bag' },
  { value: '🪙', label: 'coin' },
  { value: '💵', label: 'dollar' },
  { value: '💴', label: 'yen' },
  { value: '💶', label: 'euro' },
  { value: '💷', label: 'pound' },
  { value: '💸', label: 'flying-money' },
  { value: '💳', label: 'credit-card' },
  { value: '🧾', label: 'receipt' },
  { value: '🗝️', label: 'old-key' },
  { value: '🔑', label: 'key' },

  // ═══════════════════════════════════════════════════════════════
  // DOCUMENTS & KNOWLEDGE
  // ═══════════════════════════════════════════════════════════════
  { value: '📜', label: 'scroll' },
  { value: '📃', label: 'page-curl' },
  { value: '📄', label: 'page' },
  { value: '📰', label: 'newspaper' },
  { value: '🗞️', label: 'rolled-newspaper' },
  { value: '📑', label: 'bookmark-tabs' },
  { value: '🔖', label: 'bookmark' },
  { value: '🏷️', label: 'label' },
  { value: '📖', label: 'open-book' },
  { value: '📗', label: 'green-book' },
  { value: '📘', label: 'blue-book' },
  { value: '📙', label: 'orange-book' },
  { value: '📚', label: 'books' },
  { value: '📓', label: 'notebook' },
  { value: '📒', label: 'ledger' },
  { value: '📔', label: 'notebook-decorative' },
  { value: '📕', label: 'closed-book' },
  { value: '🗒️', label: 'spiral-notepad' },
  { value: '🗓️', label: 'calendar' },
  { value: '📅', label: 'calendar-date' },
  { value: '📆', label: 'tear-off-calendar' },
  { value: '🗃️', label: 'card-file-box' },
  { value: '🗄️', label: 'file-cabinet' },
  { value: '🗂️', label: 'card-dividers' },
  { value: '📁', label: 'folder' },
  { value: '📂', label: 'open-folder' },
  { value: '🗳️', label: 'ballot-box' },
  { value: '📋', label: 'clipboard' },
  { value: '📌', label: 'pushpin' },
  { value: '📍', label: 'round-pushpin' },
  { value: '📎', label: 'paperclip' },
  { value: '🖇️', label: 'linked-paperclips' },
  { value: '✂️', label: 'scissors' },
  { value: '🗑️', label: 'trash' },

  // Writing
  { value: '✏️', label: 'pencil' },
  { value: '✒️', label: 'black-nib' },
  { value: '🖋️', label: 'fountain-pen' },
  { value: '🖊️', label: 'pen' },
  { value: '🖌️', label: 'paintbrush' },
  { value: '🖍️', label: 'crayon' },
  { value: '📝', label: 'memo' },

  // ═══════════════════════════════════════════════════════════════
  // TOOLS & OBJECTS
  // ═══════════════════════════════════════════════════════════════
  { value: '🔒', label: 'lock' },
  { value: '🔓', label: 'unlock' },
  { value: '🔏', label: 'lock-pen' },
  { value: '🔐', label: 'lock-key' },
  { value: '⛓️', label: 'chains' },
  { value: '⛓️‍💥', label: 'broken-chain' },
  { value: '🪝', label: 'hook' },
  { value: '🧰', label: 'toolbox' },
  { value: '🧲', label: 'magnet' },
  { value: '⚙️', label: 'gear' },
  { value: '🔧', label: 'wrench' },
  { value: '🪛', label: 'screwdriver' },
  { value: '🔩', label: 'nut-bolt' },
  { value: '⚖️', label: 'scales' },
  { value: '🦯', label: 'cane' },
  { value: '🔗', label: 'link' },
  { value: '🪢', label: 'knot' },
  { value: '🧵', label: 'thread' },
  { value: '🪡', label: 'needle' },
  { value: '🧶', label: 'yarn' },
  { value: '🪤', label: 'trap' },
  { value: '🪆', label: 'nesting-dolls' },
  { value: '🎀', label: 'ribbon' },
  { value: '🎁', label: 'gift' },
  { value: '🎈', label: 'balloon' },
  { value: '🎊', label: 'confetti-ball' },
  { value: '🎉', label: 'party-popper' },
  { value: '🎏', label: 'carp-streamer' },
  { value: '🎐', label: 'wind-chime' },
  { value: '🎑', label: 'moon-ceremony' },
  { value: '🧧', label: 'red-envelope' },
  { value: '🎎', label: 'dolls' },
  { value: '🎍', label: 'pine-decoration' },
  { value: '🎋', label: 'tanabata-tree' },
  { value: '🎄', label: 'christmas-tree' },
  { value: '🎃', label: 'pumpkin' },

  // ═══════════════════════════════════════════════════════════════
  // MAPS & NAVIGATION
  // ═══════════════════════════════════════════════════════════════
  { value: '🗺️', label: 'world-map' },
  { value: '🧭', label: 'compass' },
  { value: '📍', label: 'location-pin' },
  { value: '🚩', label: 'flag' },
  { value: '🏴', label: 'black-flag' },
  { value: '🏳️', label: 'white-flag' },
  { value: '🏁', label: 'checkered-flag' },
  { value: '🎌', label: 'crossed-flags' },
  { value: '🏴‍☠️', label: 'pirate-flag' },
  { value: '⚓', label: 'anchor' },
  { value: '🧳', label: 'luggage' },
  { value: '🎒', label: 'backpack' },
  { value: '👝', label: 'pouch' },
  { value: '👛', label: 'purse' },
  { value: '👜', label: 'handbag' },
  { value: '💼', label: 'briefcase' },
  { value: '🧳', label: 'suitcase' },

  // ═══════════════════════════════════════════════════════════════
  // GAMES & ENTERTAINMENT
  // ═══════════════════════════════════════════════════════════════
  { value: '🎲', label: 'dice' },
  { value: '🎯', label: 'bullseye' },
  { value: '🎴', label: 'flower-cards' },
  { value: '🀄', label: 'mahjong' },
  { value: '🃏', label: 'joker' },
  { value: '🎰', label: 'slot-machine' },
  { value: '🎳', label: 'bowling' },
  { value: '🎮', label: 'game-controller' },
  { value: '🕹️', label: 'joystick' },
  { value: '🎪', label: 'circus-tent' },
  { value: '🎠', label: 'carousel' },
  { value: '🎡', label: 'ferris-wheel' },
  { value: '🎢', label: 'roller-coaster' },
  { value: '🎭', label: 'theater-masks' },
  { value: '🎨', label: 'palette' },
  { value: '🎬', label: 'clapperboard' },
  { value: '🎤', label: 'microphone' },
  { value: '🎧', label: 'headphones' },
  { value: '🎵', label: 'musical-note' },
  { value: '🎶', label: 'musical-notes' },
  { value: '🎹', label: 'piano' },
  { value: '🎷', label: 'saxophone' },
  { value: '🎸', label: 'guitar' },
  { value: '🎺', label: 'trumpet' },
  { value: '🎻', label: 'violin' },
  { value: '🪕', label: 'banjo' },
  { value: '🥁', label: 'drum' },
  { value: '🪘', label: 'long-drum' },
  { value: '🪇', label: 'maracas' },
  { value: '🪈', label: 'flute' },
  { value: '🪗', label: 'accordion' },

  // ═══════════════════════════════════════════════════════════════
  // FOOD & DRINKS
  // ═══════════════════════════════════════════════════════════════
  { value: '🍎', label: 'apple' },
  { value: '🍐', label: 'pear' },
  { value: '🍊', label: 'orange' },
  { value: '🍋', label: 'lemon' },
  { value: '🍇', label: 'grapes' },
  { value: '🍓', label: 'strawberry' },
  { value: '🍒', label: 'cherries' },
  { value: '🍑', label: 'peach' },
  { value: '🥝', label: 'kiwi' },
  { value: '🍅', label: 'tomato' },
  { value: '🥕', label: 'carrot' },
  { value: '🌽', label: 'corn' },
  { value: '🥔', label: 'potato' },
  { value: '🧅', label: 'onion' },
  { value: '🧄', label: 'garlic' },
  { value: '🥦', label: 'broccoli' },
  { value: '🥬', label: 'leafy-green' },
  { value: '🥒', label: 'cucumber' },
  { value: '🌶️', label: 'hot-pepper' },
  { value: '🫑', label: 'bell-pepper' },
  { value: '🍞', label: 'bread' },
  { value: '🥖', label: 'baguette' },
  { value: '🥨', label: 'pretzel' },
  { value: '🧀', label: 'cheese' },
  { value: '🥚', label: 'egg' },
  { value: '🍳', label: 'cooking' },
  { value: '🥓', label: 'bacon' },
  { value: '🥩', label: 'steak' },
  { value: '🍗', label: 'poultry-leg' },
  { value: '🍖', label: 'meat-bone' },
  { value: '🦴', label: 'bone' },
  { value: '🍕', label: 'pizza' },
  { value: '🍔', label: 'burger' },
  { value: '🍟', label: 'fries' },
  { value: '🌭', label: 'hot-dog' },
  { value: '🥪', label: 'sandwich' },
  { value: '🌮', label: 'taco' },
  { value: '🌯', label: 'burrito' },
  { value: '🥗', label: 'salad' },
  { value: '🍲', label: 'pot-food' },
  { value: '🍜', label: 'noodles' },
  { value: '🍝', label: 'spaghetti' },
  { value: '🍣', label: 'sushi' },
  { value: '🍤', label: 'fried-shrimp' },
  { value: '🍩', label: 'doughnut' },
  { value: '🍪', label: 'cookie' },
  { value: '🎂', label: 'birthday-cake' },
  { value: '🍰', label: 'cake-slice' },
  { value: '🧁', label: 'cupcake' },
  { value: '🥧', label: 'pie' },
  { value: '🍫', label: 'chocolate' },
  { value: '🍬', label: 'candy' },
  { value: '🍭', label: 'lollipop' },
  { value: '🍮', label: 'custard' },
  { value: '🍯', label: 'honey' },
  { value: '🍼', label: 'baby-bottle' },
  { value: '☕', label: 'coffee' },
  { value: '🍵', label: 'tea' },
  { value: '🧃', label: 'juice-box' },
  { value: '🥤', label: 'cup-straw' },
  { value: '🧋', label: 'bubble-tea' },
  { value: '🍶', label: 'sake' },
  { value: '🍺', label: 'beer' },
  { value: '🍻', label: 'clinking-beers' },
  { value: '🥂', label: 'champagne' },
  { value: '🍷', label: 'wine' },
  { value: '🥃', label: 'whiskey' },
  { value: '🍸', label: 'cocktail' },
  { value: '🍹', label: 'tropical-drink' },
  { value: '🧉', label: 'mate' },
  { value: '🫗', label: 'pouring' },
  { value: '🫖', label: 'teapot' },
  { value: '🍽️', label: 'plate-cutlery' },
  { value: '🍴', label: 'fork-knife' },
  { value: '🥄', label: 'spoon' },
  { value: '🥢', label: 'chopsticks' },
  { value: '🧊', label: 'ice' },
  { value: '🧂', label: 'salt' },

  // ═══════════════════════════════════════════════════════════════
  // PEOPLE & EMOTIONS
  // ═══════════════════════════════════════════════════════════════
  { value: '👤', label: 'silhouette' },
  { value: '👥', label: 'silhouettes' },
  { value: '👨', label: 'man' },
  { value: '👩', label: 'woman' },
  { value: '🧑', label: 'person' },
  { value: '👶', label: 'baby' },
  { value: '🧒', label: 'child' },
  { value: '👦', label: 'boy' },
  { value: '👧', label: 'girl' },
  { value: '🧓', label: 'elder' },
  { value: '👴', label: 'old-man' },
  { value: '👵', label: 'old-woman' },
  { value: '👨‍🦰', label: 'man-red-hair' },
  { value: '👩‍🦰', label: 'woman-red-hair' },
  { value: '👨‍🦱', label: 'man-curly-hair' },
  { value: '👩‍🦱', label: 'woman-curly-hair' },
  { value: '👨‍🦲', label: 'man-bald' },
  { value: '👩‍🦲', label: 'woman-bald' },
  { value: '👨‍🦳', label: 'man-white-hair' },
  { value: '👩‍🦳', label: 'woman-white-hair' },
  { value: '🧔', label: 'bearded' },
  { value: '👮', label: 'police' },
  { value: '👷', label: 'construction-worker' },
  { value: '💂', label: 'guard' },
  { value: '🕵️', label: 'detective' },
  { value: '👨‍⚕️', label: 'doctor-male' },
  { value: '👩‍⚕️', label: 'doctor-female' },
  { value: '👨‍🎓', label: 'graduate-male' },
  { value: '👩‍🎓', label: 'graduate-female' },
  { value: '👨‍🏫', label: 'teacher-male' },
  { value: '👩‍🏫', label: 'teacher-female' },
  { value: '👨‍⚖️', label: 'judge-male' },
  { value: '👩‍⚖️', label: 'judge-female' },
  { value: '👨‍🌾', label: 'farmer-male' },
  { value: '👩‍🌾', label: 'farmer-female' },
  { value: '👨‍🍳', label: 'chef-male' },
  { value: '👩‍🍳', label: 'chef-female' },
  { value: '👨‍🔧', label: 'mechanic-male' },
  { value: '👩‍🔧', label: 'mechanic-female' },
  { value: '👨‍🔬', label: 'scientist-male' },
  { value: '👩‍🔬', label: 'scientist-female' },
  { value: '👨‍🎨', label: 'artist-male' },
  { value: '👩‍🎨', label: 'artist-female' },
  { value: '👨‍🚒', label: 'firefighter-male' },
  { value: '👩‍🚒', label: 'firefighter-female' },
  { value: '👨‍✈️', label: 'pilot-male' },
  { value: '👩‍✈️', label: 'pilot-female' },
  { value: '👨‍🚀', label: 'astronaut-male' },
  { value: '👩‍🚀', label: 'astronaut-female' },
  { value: '🧑‍🤝‍🧑', label: 'holding-hands' },
  { value: '👫', label: 'couple' },
  { value: '👬', label: 'men-holding-hands' },
  { value: '👭', label: 'women-holding-hands' },
  { value: '👪', label: 'family' },

  // Body Parts
  { value: '👁️', label: 'eye' },
  { value: '👀', label: 'eyes' },
  { value: '👂', label: 'ear' },
  { value: '👃', label: 'nose' },
  { value: '👅', label: 'tongue' },
  { value: '👄', label: 'mouth' },
  { value: '🫀', label: 'heart-organ' },
  { value: '🫁', label: 'lungs' },
  { value: '🧠', label: 'brain' },
  { value: '🦷', label: 'tooth' },
  { value: '🦴', label: 'bone' },
  { value: '👣', label: 'footprints' },
  { value: '🦶', label: 'foot' },
  { value: '🦵', label: 'leg' },
  { value: '💪', label: 'muscle' },
  { value: '🦾', label: 'mechanical-arm' },
  { value: '🦿', label: 'mechanical-leg' },
  { value: '👋', label: 'waving-hand' },
  { value: '🤚', label: 'raised-back-hand' },
  { value: '🖐️', label: 'hand-fingers-splayed' },
  { value: '✋', label: 'raised-hand' },
  { value: '🖖', label: 'vulcan-salute' },
  { value: '👌', label: 'ok-hand' },
  { value: '🤌', label: 'pinched-fingers' },
  { value: '🤏', label: 'pinching-hand' },
  { value: '✌️', label: 'victory-hand' },
  { value: '🤞', label: 'crossed-fingers' },
  { value: '🫰', label: 'hand-heart' },
  { value: '🤟', label: 'love-you' },
  { value: '🤘', label: 'rock-on' },
  { value: '🤙', label: 'call-me' },
  { value: '👈', label: 'point-left' },
  { value: '👉', label: 'point-right' },
  { value: '👆', label: 'point-up' },
  { value: '👇', label: 'point-down' },
  { value: '☝️', label: 'index-up' },
  { value: '👍', label: 'thumbs-up' },
  { value: '👎', label: 'thumbs-down' },
  { value: '✊', label: 'raised-fist' },
  { value: '👊', label: 'fist' },
  { value: '🤛', label: 'left-fist' },
  { value: '🤜', label: 'right-fist' },
  { value: '👏', label: 'clapping' },
  { value: '🙌', label: 'raising-hands' },
  { value: '🫶', label: 'heart-hands' },
  { value: '👐', label: 'open-hands' },
  { value: '🤲', label: 'palms-up' },
  { value: '🤝', label: 'handshake' },
  { value: '🙏', label: 'pray' },

  // Faces & Emotions
  { value: '😀', label: 'grinning' },
  { value: '😃', label: 'smiley' },
  { value: '😄', label: 'smile' },
  { value: '😁', label: 'grin' },
  { value: '😆', label: 'laughing' },
  { value: '😅', label: 'sweat-smile' },
  { value: '🤣', label: 'rofl' },
  { value: '😂', label: 'joy' },
  { value: '🙂', label: 'slight-smile' },
  { value: '🙃', label: 'upside-down' },
  { value: '🫠', label: 'melting' },
  { value: '😉', label: 'wink' },
  { value: '😊', label: 'blush' },
  { value: '😇', label: 'innocent' },
  { value: '🥰', label: 'love-face' },
  { value: '😍', label: 'heart-eyes' },
  { value: '🤩', label: 'star-struck' },
  { value: '😘', label: 'kiss' },
  { value: '😗', label: 'kissing' },
  { value: '☺️', label: 'relaxed' },
  { value: '😚', label: 'kissing-closed-eyes' },
  { value: '😋', label: 'yum' },
  { value: '😛', label: 'tongue-out' },
  { value: '😜', label: 'crazy' },
  { value: '🤪', label: 'zany' },
  { value: '😝', label: 'squinting-tongue' },
  { value: '🤑', label: 'money-face' },
  { value: '🤗', label: 'hugs' },
  { value: '🤭', label: 'hand-over-mouth' },
  { value: '🫢', label: 'shush' },
  { value: '🫣', label: 'peeking' },
  { value: '🤫', label: 'shushing' },
  { value: '🤔', label: 'thinking' },
  { value: '🫡', label: 'salute' },
  { value: '🤐', label: 'zipper-mouth' },
  { value: '🤨', label: 'raised-eyebrow' },
  { value: '😐', label: 'neutral' },
  { value: '😑', label: 'expressionless' },
  { value: '😶', label: 'no-mouth' },
  { value: '🫥', label: 'dotted-line' },
  { value: '😏', label: 'smirk' },
  { value: '😒', label: 'unamused' },
  { value: '🙄', label: 'eye-roll' },
  { value: '😬', label: 'grimace' },
  { value: '🫨', label: 'shaking' },
  { value: '😮‍💨', label: 'exhale' },
  { value: '🤥', label: 'lying' },
  { value: '🫤', label: 'diagonal-mouth' },
  { value: '😌', label: 'relieved' },
  { value: '😔', label: 'pensive' },
  { value: '😪', label: 'sleepy' },
  { value: '🤤', label: 'drooling' },
  { value: '😴', label: 'sleeping' },
  { value: '😷', label: 'mask' },
  { value: '🤒', label: 'thermometer' },
  { value: '🤕', label: 'bandage' },
  { value: '🤢', label: 'nauseated' },
  { value: '🤮', label: 'vomiting' },
  { value: '🤧', label: 'sneezing' },
  { value: '🥵', label: 'hot' },
  { value: '🥶', label: 'cold' },
  { value: '🥴', label: 'woozy' },
  { value: '😵', label: 'dizzy' },
  { value: '😵‍💫', label: 'spiral-eyes' },
  { value: '🤯', label: 'mind-blown' },
  { value: '🤠', label: 'cowboy' },
  { value: '🥳', label: 'partying' },
  { value: '🥸', label: 'disguise' },
  { value: '😎', label: 'cool' },
  { value: '🤓', label: 'nerd' },
  { value: '🧐', label: 'monocle' },
  { value: '😕', label: 'confused' },
  { value: '🫤', label: 'skeptical' },
  { value: '😟', label: 'worried' },
  { value: '🙁', label: 'slightly-frown' },
  { value: '☹️', label: 'frown' },
  { value: '😮', label: 'open-mouth' },
  { value: '😯', label: 'hushed' },
  { value: '😲', label: 'astonished' },
  { value: '😳', label: 'flushed' },
  { value: '🥺', label: 'pleading' },
  { value: '🥹', label: 'holding-tears' },
  { value: '😦', label: 'frowning-mouth' },
  { value: '😧', label: 'anguished' },
  { value: '😨', label: 'fearful' },
  { value: '😰', label: 'anxious' },
  { value: '😥', label: 'sad-relieved' },
  { value: '😢', label: 'crying' },
  { value: '😭', label: 'loudly-crying' },
  { value: '😱', label: 'scream' },
  { value: '😖', label: 'confounded' },
  { value: '😣', label: 'persevere' },
  { value: '😞', label: 'disappointed' },
  { value: '😓', label: 'downcast-sweat' },
  { value: '😩', label: 'weary' },
  { value: '😫', label: 'tired' },
  { value: '🥱', label: 'yawn' },
  { value: '😤', label: 'triumph' },
  { value: '😡', label: 'angry' },
  { value: '😠', label: 'pouting' },
  { value: '🤬', label: 'cursing' },

  // ═══════════════════════════════════════════════════════════════
  // STATUS & SYMBOLS
  // ═══════════════════════════════════════════════════════════════
  { value: '❤️', label: 'red-heart' },
  { value: '🧡', label: 'orange-heart' },
  { value: '💛', label: 'yellow-heart' },
  { value: '💚', label: 'green-heart' },
  { value: '💙', label: 'blue-heart' },
  { value: '💜', label: 'purple-heart' },
  { value: '🖤', label: 'black-heart' },
  { value: '🤍', label: 'white-heart' },
  { value: '🤎', label: 'brown-heart' },
  { value: '💔', label: 'broken-heart' },
  { value: '❤️‍🔥', label: 'heart-fire' },
  { value: '❤️‍🩹', label: 'mending-heart' },
  { value: '❣️', label: 'heart-exclamation' },
  { value: '💕', label: 'two-hearts' },
  { value: '💞', label: 'revolving-hearts' },
  { value: '💓', label: 'beating-heart' },
  { value: '💗', label: 'growing-heart' },
  { value: '💖', label: 'sparkling-heart' },
  { value: '💘', label: 'cupid' },
  { value: '💝', label: 'gift-heart' },
  { value: '💟', label: 'heart-decoration' },
  { value: '☮️', label: 'peace' },
  { value: '✝️', label: 'cross' },
  { value: '☪️', label: 'star-crescent' },
  { value: '🕉️', label: 'om-symbol' },
  { value: '☸️', label: 'dharma-wheel' },
  { value: '✡️', label: 'star-david' },
  { value: '🔯', label: 'six-star' },
  { value: '🕎', label: 'menorah' },
  { value: '☯️', label: 'yin-yang' },
  { value: '☦️', label: 'orthodox-cross' },
  { value: '🛐', label: 'worship' },
  { value: '⛎', label: 'ophiuchus' },
  { value: '♈', label: 'aries' },
  { value: '♉', label: 'taurus' },
  { value: '♊', label: 'gemini' },
  { value: '♋', label: 'cancer' },
  { value: '♌', label: 'leo' },
  { value: '♍', label: 'virgo' },
  { value: '♎', label: 'libra' },
  { value: '♏', label: 'scorpio' },
  { value: '♐', label: 'sagittarius' },
  { value: '♑', label: 'capricorn' },
  { value: '♒', label: 'aquarius' },
  { value: '♓', label: 'pisces' },
  { value: '⚧️', label: 'transgender' },
  { value: '✖️', label: 'multiply' },
  { value: '➕', label: 'plus' },
  { value: '➖', label: 'minus' },
  { value: '➗', label: 'divide' },
  { value: '🟰', label: 'equals' },
  { value: '♻️', label: 'recycle' },
  { value: '⚜️', label: 'fleur-de-lis' },
  { value: '🔱', label: 'trident' },
  { value: '📛', label: 'name-badge' },
  { value: '🔰', label: 'beginner' },
  { value: '⭕', label: 'circle-o' },
  { value: '✅', label: 'check-mark' },
  { value: '☑️', label: 'ballot-check' },
  { value: '✔️', label: 'check' },
  { value: '❌', label: 'cross-mark' },
  { value: '❎', label: 'cross-mark-button' },
  { value: '➰', label: 'curly-loop' },
  { value: '➿', label: 'double-loop' },
  { value: '〽️', label: 'part-alternation' },
  { value: '✳️', label: 'eight-spoked' },
  { value: '✴️', label: 'eight-pointed' },
  { value: '❇️', label: 'sparkle' },
  { value: '©️', label: 'copyright' },
  { value: '®️', label: 'registered' },
  { value: '™️', label: 'trademark' },
  { value: '#️⃣', label: 'hash-key' },
  { value: '*️⃣', label: 'asterisk-key' },
  { value: '0️⃣', label: 'zero' },
  { value: '1️⃣', label: 'one' },
  { value: '2️⃣', label: 'two' },
  { value: '3️⃣', label: 'three' },
  { value: '4️⃣', label: 'four' },
  { value: '5️⃣', label: 'five' },
  { value: '6️⃣', label: 'six' },
  { value: '7️⃣', label: 'seven' },
  { value: '8️⃣', label: 'eight' },
  { value: '9️⃣', label: 'nine' },
  { value: '🔟', label: 'ten' },
  { value: '🔢', label: 'numbers' },
  { value: '🔣', label: 'symbols' },
  { value: '🔤', label: 'letters' },
  { value: '🔠', label: 'uppercase' },
  { value: '🔡', label: 'lowercase' },
  { value: 'ℹ️', label: 'info' },
  { value: '🆎', label: 'ab-button' },
  { value: '🆑', label: 'cl-button' },
  { value: '🆒', label: 'cool-button' },
  { value: '🆓', label: 'free-button' },
  { value: '🆔', label: 'id-button' },
  { value: '🆕', label: 'new-button' },
  { value: '🆖', label: 'ng-button' },
  { value: '🆗', label: 'ok-button' },
  { value: '🆘', label: 'sos-button' },
  { value: '🆙', label: 'up-button' },
  { value: '🆚', label: 'vs-button' },
  { value: '🔴', label: 'red-circle' },
  { value: '🟠', label: 'orange-circle' },
  { value: '🟡', label: 'yellow-circle' },
  { value: '🟢', label: 'green-circle' },
  { value: '🔵', label: 'blue-circle' },
  { value: '🟣', label: 'purple-circle' },
  { value: '🟤', label: 'brown-circle' },
  { value: '⚫', label: 'black-circle' },
  { value: '⚪', label: 'white-circle' },
  { value: '🟥', label: 'red-square' },
  { value: '🟧', label: 'orange-square' },
  { value: '🟨', label: 'yellow-square' },
  { value: '🟩', label: 'green-square' },
  { value: '🟦', label: 'blue-square' },
  { value: '🟪', label: 'purple-square' },
  { value: '🟫', label: 'brown-square' },
  { value: '⬛', label: 'black-large-square' },
  { value: '⬜', label: 'white-large-square' },
  { value: '◼️', label: 'black-medium-square' },
  { value: '◻️', label: 'white-medium-square' },
  { value: '◾', label: 'black-med-sm-square' },
  { value: '◽', label: 'white-med-sm-square' },
  { value: '▪️', label: 'black-small-square' },
  { value: '▫️', label: 'white-small-square' },
  { value: '🔶', label: 'orange-diamond-lg' },
  { value: '🔷', label: 'blue-diamond-lg' },
  { value: '🔸', label: 'orange-diamond-sm' },
  { value: '🔹', label: 'blue-diamond-sm' },
  { value: '🔺', label: 'red-triangle-up' },
  { value: '🔻', label: 'red-triangle-down' },
  { value: '💠', label: 'diamond-dot' },
  { value: '🔘', label: 'radio-button' },
  { value: '🔳', label: 'white-square-button' },
  { value: '🔲', label: 'black-square-button' },
  { value: '⚠️', label: 'warning' },
  { value: '🚫', label: 'prohibited' },
  { value: '🚷', label: 'no-pedestrians' },
  { value: '🚯', label: 'no-littering' },
  { value: '🚳', label: 'no-bicycles' },
  { value: '🚱', label: 'no-water' },
  { value: '❓', label: 'question-red' },
  { value: '❔', label: 'question-white' },
  { value: '❗', label: 'exclamation-red' },
  { value: '❕', label: 'exclamation-white' },
  { value: '‼️', label: 'double-exclamation' },
  { value: '⁉️', label: 'exclamation-question' },
  { value: '💯', label: 'hundred' },
  { value: '🔞', label: 'no-under-18' },
  { value: '📵', label: 'no-phones' },
  { value: '🔇', label: 'mute' },
  { value: '🔈', label: 'speaker-low' },
  { value: '🔉', label: 'speaker-medium' },
  { value: '🔊', label: 'speaker-high' },
  { value: '🔔', label: 'bell' },
  { value: '🔕', label: 'bell-slash' },
  { value: '💡', label: 'lightbulb' },

  // ═══════════════════════════════════════════════════════════════
  // ARROWS & DIRECTIONS
  // ═══════════════════════════════════════════════════════════════
  { value: '⬆️', label: 'arrow-up' },
  { value: '↗️', label: 'arrow-up-right' },
  { value: '➡️', label: 'arrow-right' },
  { value: '↘️', label: 'arrow-down-right' },
  { value: '⬇️', label: 'arrow-down' },
  { value: '↙️', label: 'arrow-down-left' },
  { value: '⬅️', label: 'arrow-left' },
  { value: '↖️', label: 'arrow-up-left' },
  { value: '↕️', label: 'arrow-up-down' },
  { value: '↔️', label: 'arrow-left-right' },
  { value: '↩️', label: 'arrow-return-left' },
  { value: '↪️', label: 'arrow-return-right' },
  { value: '⤴️', label: 'arrow-curve-up' },
  { value: '⤵️', label: 'arrow-curve-down' },
  { value: '🔃', label: 'arrows-clockwise' },
  { value: '🔄', label: 'arrows-counter' },
  { value: '🔙', label: 'back-arrow' },
  { value: '🔚', label: 'end-arrow' },
  { value: '🔛', label: 'on-arrow' },
  { value: '🔜', label: 'soon-arrow' },
  { value: '🔝', label: 'top-arrow' }
]

export default EMOJI_ICONS
